import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { colorOf } from "@/lib/colors";

export const WEEKDAYS = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab"];

const toggle = (xs, v) => (xs.includes(v) ? xs.filter((x) => x !== v) : [...xs, v]);

export const usualSummary = (task, empById) => {
  const days = [...(task.usual_days || [])].sort().map((i) => WEEKDAYS[i]);
  const names = (task.usual_employee_ids || []).map((id) => empById[id]?.name).filter(Boolean);
  if (!days.length || !names.length) return "";
  return `${days.join(", ")} · ${names.join(", ")}`;
};

export const RecurringHabits = ({ form, setForm, employees }) => (
  <div data-testid="recurring-habits" className="col-span-2 space-y-2 rounded-xl border border-violet-100 p-3">
    <Label className="text-xs font-medium text-slate-600">Dipendenti abituali</Label>
    <div className="flex flex-wrap gap-1.5">
      {employees.map((e) => {
        const c = colorOf(e);
        const active = form.usual_employee_ids.includes(e.id);
        return (
          <button
            key={e.id}
            type="button"
            data-testid={`usual-employee-${e.id}`}
            aria-pressed={active}
            onClick={() => setForm((f) => ({ ...f, usual_employee_ids: toggle(f.usual_employee_ids, e.id) }))}
            className="min-h-[36px] rounded-full border px-3 text-xs font-semibold transition-shadow"
            style={{ background: active ? c.bg : "#fff", borderColor: active ? c.accent : "#e2e8f0", color: active ? c.ink : "#64748b", boxShadow: active ? `0 0 0 1px ${c.accent}` : "none" }}
          >
            {e.name}
          </button>
        );
      })}
    </div>
    <Label className="block pt-1 text-xs font-medium text-slate-600">Giorni abituali</Label>
    <div className="grid grid-cols-6 gap-1.5">
      {WEEKDAYS.map((d, i) => (
        <button
          key={d}
          type="button"
          data-testid={`usual-day-${i}`}
          aria-pressed={form.usual_days.includes(i)}
          onClick={() => setForm((f) => ({ ...f, usual_days: toggle(f.usual_days, i) }))}
          className={`day-chip w-full !min-w-0 px-0 py-2 ${form.usual_days.includes(i) ? "is-active" : ""}`}
        >
          <span className="font-display text-xs font-semibold">{d}</span>
        </button>
      ))}
    </div>
    <p className="text-[11px] text-slate-500">Salvando, la ricorrente va subito nella settimana che stai guardando.</p>
    <label htmlFor="task-auto-weekly" className="flex min-h-[40px] cursor-pointer items-center gap-2.5 rounded-lg bg-emerald-50/70 px-2.5 text-xs font-medium text-emerald-900">
      <Checkbox id="task-auto-weekly" data-testid="task-auto-weekly-checkbox" checked={form.auto_weekly} onCheckedChange={(v) => setForm((f) => ({ ...f, auto_weekly: v === true }))} className="h-4 w-4 rounded-[4px]" />
      Assegna in automatico a tutte le settimane
    </label>
  </div>
);
